/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

import type * as Types from '@root/gql/graphql';

import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { UseQueryResult } from '@tanstack/react-query';
import { QueryClient } from '@tanstack/react-query';
import { gqlRequest } from '@root/gql/utils/gqlRequest';
import { getDiscountCalculationsQuery } from '../graphs/getDiscountCalculations.query';

export type GetDiscountCalculationsQueryVariables = Types.Exact<{
  dto: Types.GetDiscountCalculationsDto;
}>;

export type GetDiscountCalculationsQuery = {
  __typename?: 'Query';
  discountCalculations?: {
    __typename?: 'GetDiscountCalculationsResponseDto';
    possiblePurchasesWithDiscount: Array<{
      __typename?: 'PossiblePurchaseWithDiscountDto';
      productId: number;
      productOptionId?: number | null;
      discountedPrice: number;
      discountedPriceOffersOnly: number;
      fullPrice: number;
      discount?: {
        __typename?: 'DiscountAggregate';
        name: string;
        promoCode?: string | null;
        priceReduction: { __typename?: 'PriceReductionFieldValue'; value: number; type: string };
      } | null;
      discountOffersOnly?: {
        __typename?: 'DiscountAggregate';
        name: string;
        priceReduction: { __typename?: 'PriceReductionFieldValue'; value: number; type: string };
      } | null;
    }>;
  } | null;
};

export const getDiscountCalculationsQueryImperative = (
  variables: GetDiscountCalculationsQueryVariables,
  headers?: RequestInit['headers']
) =>
  gqlRequest<GetDiscountCalculationsQuery, GetDiscountCalculationsQueryVariables>(
    getDiscountCalculationsQuery,
    variables,
    headers
  );

export const getDiscountCalculationsQueryKey = (
  variables?: GetDiscountCalculationsQueryVariables
) => ['GetDiscountCalculations', variables].filter((x) => x);

export const getDiscountCalculationsQueryPrefetch = async (
  queryClient: QueryClient,
  variables: GetDiscountCalculationsQueryVariables,
  options?: {
    headers?: RequestInit['headers'];
  }
) => {
  await queryClient.prefetchQuery(getDiscountCalculationsQueryKey(variables), () =>
    getDiscountCalculationsQueryImperative(variables, options?.headers)
  );
};

export const useGetDiscountCalculationsQuery = <TError = unknown>(
  variables: GetDiscountCalculationsQueryVariables,
  options?: UseQueryOptions<GetDiscountCalculationsQuery, TError, GetDiscountCalculationsQuery>,
  headers?: RequestInit['headers']
): UseQueryResult<GetDiscountCalculationsQuery> =>
  useQuery<GetDiscountCalculationsQuery, TError, GetDiscountCalculationsQuery>(
    ['GetDiscountCalculations', variables],
    () =>
      getDiscountCalculationsQueryImperative(
        variables as GetDiscountCalculationsQueryVariables,
        headers
      ),
    options
  );
